import React, { FC, useState } from 'react';
import { LangChangeButton, LangChangeTitle, LangIconImg } from './ChangeLangDrop.styles';
import { ISingleFlag, langMenuDropArr } from '../../constans/flags';
import FlexibleDropdown, { IDropdownItem } from '../../HOC/FlexibleDropdown/FlexibleDropdown';
import { useLangManagement } from '../../hooks/useLangManagement';

interface IChangeLangDrop {
  anchor?: 'top' | 'bottom';
  positionX?: string;
  positionY?: string;
  width?: string;
}

const ChangeLangDrop: FC<IChangeLangDrop> = ({ anchor, positionX, positionY, width }) => {
  const [activeIcon, setActiveIcon] = useState(false);
  const { currentLanguageObject, changeLanguage } = useLangManagement();
  const fallbackLanguage: ISingleFlag = {
    id: '',
    flagName: '',
    shortName: 'en',
    shortDisplayName: '',
    name: '',
    icon: '',
  };
  const languageObject = currentLanguageObject || fallbackLanguage;

  return (
    <FlexibleDropdown
      activeTile={{ key: 'name', value: languageObject.name }}
      items={langMenuDropArr}
      setActiveIcon={setActiveIcon}
      getSelectedItem={(item: IDropdownItem) => changeLanguage(item.shortName as string)}
      {...{ anchor, positionX, positionY, width }}
    >
      <LangChangeButton data-testid="langIconButton" active={activeIcon}>
        <LangIconImg src={languageObject.icon} alt="" />
        <LangChangeTitle>{languageObject.shortDisplayName}</LangChangeTitle>
      </LangChangeButton>
    </FlexibleDropdown>
  );
};
export default ChangeLangDrop;
